import React, { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Form, Tooltip } from "react-bootstrap";
import { Helmet } from "react-helmet";

export const TranslationMeta = (props) => {
  const [t] = useTranslation();
  if (props.error) {
    return (
      <>
        <Helmet>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="theme-color" content="#000000" />

          <title>{props.title}</title>
          <meta name="description" content={props.description} />
          <meta name="keywords" content={props.keywords} />

          <meta name="author" content="Luckiwi" />
          <meta name="copyright" content="Luckiwi" />
          <meta name="url" content="https://www.luckiwi.com/" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@luckiwipm" />
          <meta name="twitter:title" content={props.title} />
          <meta name="twitter:description" content={props.description} />
          <meta
            name="twitter:image"
            content="https://www.luckiwi.com/img/logo.webp"
          />

          <meta property="og:title" content={props.title} />
          <meta property="og:description" content={props.description} />
          <meta
            property="og:image"
            content="https://www.luckiwi.com/img/logo.webp"
          />
          <meta property="og:type" content="text/html" />
          <meta property="og:url" content={`${window.location.href}`} />

          <meta
            http-equiv="content-language"
            content={`${props.lang}-${props.lang}`}
          />
          <meta name="errorpage" content="true" />
          <meta name="errortype" content="404 - Not Found" />
          <meta name="prerender-status-code" content="404" />
        </Helmet>
      </>
    );
  } else {
    return (
      <>
        <Helmet>
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
          <meta name="theme-color" content="#000000" />

          <title>{t(props.title)}</title>
          <meta name="description" content={t(props.description)} />
          <meta name="keywords" content={t(props.keywords)} />

          <meta name="author" content="Luckiwi" />
          <meta name="copyright" content="Luckiwi" />
          <meta name="url" content="https://www.luckiwi.com/" />

          <meta name="twitter:card" content="summary" />
          <meta name="twitter:site" content="@luckiwipm" />
          <meta name="twitter:title" content={t(props.title)} />
          <meta name="twitter:description" content={t(props.description)} />
          <meta
            name="twitter:image"
            content="https://www.luckiwi.com/img/logo.webp"
          />

          <meta property="og:title" content={t(props.title)} />
          <meta property="og:description" content={t(props.description)} />
          <meta
            property="og:image"
            content="https://www.luckiwi.com/img/logo.webp"
          />
          <meta property="og:type" content="text/html" />
          <meta property="og:url" content={`${window.location.href}`} />

          <meta
            http-equiv="content-language"
            content={`${props.lang}-${props.lang}`}
          />
          <meta name="errorpage" content="true" />
          <meta name="errortype" content="404 - Not Found" />
          <meta name="prerender-status-code" content="404" />
        </Helmet>
      </>
    );
  }
};

export const TranslationCheck = (props) => {
  const [t] = useTranslation();
  return (
    <Form.Check
      type={props.type}
      label={t(props.label)}
      name={props.name}
      id={props.id}
      checked={props.checked}
      onClick={
        props.onClick
          ? (e) => {
              if (props.type === "checkbox" || props.onClick) props.onClick(e);
            }
          : null
      }
      defaultChecked={props.defaultChecked}
    />
  );
};

export const Translation = (props) => {
  const [t] = useTranslation();
  return <Fragment>{t(props.str)}</Fragment>;
};

export const BlogTranslation = (props) => {
  const [t] = useTranslation(["common", "blog", "collaboration"]);
  return <Fragment>{t(props.str)}</Fragment>;
};

export function TranslationStr(str) {}

export const TranslationTextarea = (props) => {
  const [t] = useTranslation();
  const auto_grow = async () => {
    try {
      // try needed because of some wrong props.id
      const el = await document.querySelector(`#${props.id}`);
      if (el) {
        if (el.scrollHeight >= 350) el.style.overflow = "auto";
        el.style.height = "5px";
        el.style.height =
          document.getElementById(`${props.id}`).scrollHeight + "px";
      }
    } catch {}
  };
  return (
    <textarea
      name={props.name}
      id={props.id}
      required={props.required == "true" ? true : false}
      className={props.className}
      style={props.style}
      placeholder={t(props.placeholder)}
      value={props.value}
      onChange={(e) => {
        props.onChange(e);
      }}
      onClick={(e) => {
        e.stopPropagation(); //otherwise parent div also clicked
      }}
      autoFocus={props.autoFocus ? true : false}
      oninput={auto_grow()}
    />
  );
};

export const TranslationImage = (props) => {
  const [t] = useTranslation();
  return <img src={props.src} alt={t(props.alt)} />;
};

export const TranslationInput = (props) => {
  const [t] = useTranslation();
  if (props.autoFocus) {
    return (
      <input
        required={props.required == "true" ? true : false}
        type={props.type ? props.type : "Text"}
        name={props.name}
        id={props.id}
        className={props.className}
        placeholder={t(props.placeholder)}
        value={props.value}
        onChange={(e) => {
          props.onChange(e);
        }}
        style={props.style}
        autoFocus
      />
    );
  } else if (props.visible) {
    return (
      <div style={{ display: "flex", position: "relative", width: "100%" }}>
        <input
          required={props.required == "true" ? true : false}
          type={props.type ? props.type : "Text"}
          name={props.name}
          id={props.id}
          className={props.className}
          placeholder={t(props.placeholder)}
          value={props.value}
          onChange={(e) => {
            props.onChange(e);
          }}
          style={props.style}
        />
        <img
          src="../../img/visibility.png"
          style={{
            width: "20px",
            right: "10px",
            top: "12.5px",
            position: "absolute",
            cursor: "pointer",
          }}
          alt="image visible"
          onClick={(e) =>
            e.target.previousElementSibling.type == "text"
              ? (e.target.previousElementSibling.type = "password")
              : (e.target.previousElementSibling.type = "text")
          }
        />
      </div>
    );
  } else {
    return (
      <input
        required={props.required == "true" ? true : false}
        type={props.type ? props.type : "Text"}
        name={props.name}
        id={props.id}
        className={props.className}
        // placeholder={"Add your ongoing projects..."}
        placeholder={t(props.placeholder)}
        value={props.value}
        onChange={(e) => {
          props.onChange(e);
        }}
        style={props.style}
      />
    );
  }
};

export const TranslationControl = (props) => {
  const [t] = useTranslation();
  return (
    <Form.Control
      onChange={(e) => {
        props.onChange(e);
      }}
      as={props.as}
      placeholder={t(props.str)}
      value={props.value}
      style={props.style}
      className={props.className}
      onKeyDown={(e) => {
        if (props.onKeyDown) props.onKeyDown(e);
      }}
      // autoFocus={props.autoFocus ? true : false}
      // rows={3}
      autoFocus={props.autoFocus ? true : false}
      isInvalid={props.isInvalid}
    />
  );
};

export const TranslationTooltip = (props) => {
  const [t] = useTranslation();
  return <Tooltip id="button-tooltip">df{t(props.str)}</Tooltip>;
};
